import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
export const workFlowGridColumnsDetail = () => [
    {
        field: 'transition',
        headerName: 'Transition',
        resizable: true,
        wrapText: true,
        autoHeight: true,
        flex: 1
    },
    {
        field: 'from_status',
        headerName: 'From Status',
        resizable: true,
        wrapText: true,
        autoHeight: true,
        hide: true,
        flex: 1
    },
    {
        field: 'to_status',
        headerName: 'To Status',
        resizable: true,
        wrapText: true,
        autoHeight: true,
        hide: true,
        flex: 1
    },
    {
        field: 'work_items',
        headerName: apiProvider.getEntityUpper() + 's',
        resizable: true,
        wrapText: true,
        autoHeight: true,
        flex: 1
    },


];

export function numberWithCommas(x) {
    if (x === -1) return ''
    return Number(x).toLocaleString()
}

export function formatPercentage(x, decimals) {
    if (x === -1) return ''
    else return (x * 100).toFixed(decimals) + '%';
}

